import Vue from 'vue';
import {
    BootstrapVue,
    BIcon,
    BIconArrowClockwise,
    BIconBuilding,
    BIconCalendar3,
    BIconCalendar4Event,
    BIconCalendar4Week,
    BIconCalendarCheck,
    BIconCalculator,
    BIconCardChecklist,
    BIconCaretDownFill,
    BIconClipboardCheck,
    BIconClipboardData,
    BIconCheckCircle,
    BIconChevronBarExpand,
    BIconChevronDoubleLeft,
    BIconChevronDoubleRight,
    BIconChevronDown,
    BIconChevronRight,
    BIconChevronUp,
    BIconDash,
    BIconDashCircle,
    BIconDownload,
    BIconEnvelopeFill,
    BIconExclamationTriangleFill,
    BIconEye,
    BIconGear,
    BIconGearFill,
    BIconTable,
    BIconTrashFill,
    BIconTriangleFill,
    BIconTranslate,
    BIconInfoCircle,
    BIconInfoCircleFill,
    BIconPencilSquare,
    BIconSearch,
    BIconUpload,
    BIconPlus,
    BIconXCircle,
    BIconExclamationCircleFill,
    BIconCheckCircleFill,
    BIconDot,
    BToaster,
    BIconFileEarmarkTextFill
} from 'bootstrap-vue';
import CustomModal from '@core/plugins/customModal';
Vue.use(BootstrapVue, {
    breakpoints: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'sl', 'sxl']
});
Vue.use(CustomModal); 

Vue.component('BIcon', BIcon);

Vue.component('BIconArrowClockwise', BIconArrowClockwise);
Vue.component('BIconBuilding', BIconBuilding);
Vue.component('BIconCalendar3', BIconCalendar3);
Vue.component('BIconCalendar4Event', BIconCalendar4Event);
Vue.component('BIconCalendar4Week', BIconCalendar4Week);
Vue.component('BIconCalendarCheck', BIconCalendarCheck);
Vue.component('BIconCalculator', BIconCalculator);
Vue.component('BIconCaretDownFill', BIconCaretDownFill);
Vue.component('BIconCardChecklist', BIconCardChecklist);
Vue.component('BIconClipboardCheck', BIconClipboardCheck);
Vue.component('BIconClipboardData', BIconClipboardData);
Vue.component('BIconCheckCircle', BIconCheckCircle);
Vue.component('BIconChevronBarExpand', BIconChevronBarExpand);
Vue.component('BIconChevronDoubleLeft', BIconChevronDoubleLeft);
Vue.component('BIconChevronDoubleRight', BIconChevronDoubleRight);
Vue.component('BIconChevronDown', BIconChevronDown);
Vue.component('BIconChevronRight', BIconChevronRight);
Vue.component('BIconChevronUp', BIconChevronUp);
Vue.component('BIconDash', BIconDash);
Vue.component('BIconDashCircle', BIconDashCircle);
Vue.component('BIconDownload', BIconDownload);
Vue.component('BIconEnvelopeFill', BIconEnvelopeFill);
Vue.component('BIconExclamationTriangleFill', BIconExclamationTriangleFill);
Vue.component('BIconEye', BIconEye);
Vue.component('BIconGear', BIconGear);
Vue.component('BIconGearFill', BIconGearFill);
Vue.component('BIconTable', BIconTable);
Vue.component('BIconTrashFill', BIconTrashFill);
Vue.component('BIconTranslate', BIconTranslate);
Vue.component('BIconTriangleFill', BIconTriangleFill);
Vue.component('BIconInfoCircle', BIconInfoCircle);
Vue.component('BIconInfoCircleFill', BIconInfoCircleFill);
Vue.component('BIconPencilSquare', BIconPencilSquare);
Vue.component('BIconSearch', BIconSearch);
Vue.component('BIconUpload', BIconUpload);
Vue.component('BIconPlus', BIconPlus);
Vue.component('BIconXCircle', BIconXCircle);
Vue.component('BIconExclamationCircleFill', BIconExclamationCircleFill);
Vue.component('BIconCheckCircleFill', BIconCheckCircleFill);
Vue.component('BIconDot', BIconDot);
Vue.component('BToaster', BToaster);
Vue.component('BIconFileEarmarkTextFill', BIconFileEarmarkTextFill);
